import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationZmartaSeConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Zmarta AB',
    number: '556647-0737',
  },
};
